function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "heart");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "edit"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notepad"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.24,7.39,18.47,4.62a1.72,1.72,0,0,0-2.42,0h0L6,14.69l-.2.2L4,21.87l7-1.75.65-.66h0l9.64-9.65h0A1.72,1.72,0,0,0,21.24,7.39ZM6.46,15.59l3.81,3.81-3.57.9L5.58,19.12ZM11,17.05,8.81,14.88l7.24-7.23,2.16,2.16Z"
})));

const SvgPencil = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.7125dace.svg";
export { ForwardRef as ReactComponent };